<template>
  <section id="profile">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 portfolio-item">
          <h2 class="section-heading text-uppercase">Profile</h2>
          (自己紹介)
          <hr />
        </div>
      </div>

      <div id="profile-container" class="row">
        <div class="col-sm-3 col-12">
          <img
            id="myFace"
            src="@/assets/icon/portfolio.png"
            class="mx-auto d-block"
            alt="..."
          />
        </div>
        <div class="col-sm-9 col-12">
          <div id="profileDescription">
            <h5>エンジニア 小野隆之</h5>

            <div>
              <a
                href="https://www.facebook.com/profile.php?id=100001723150467"
                target="_blank"
              >
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/fbIcon.png"
                  alt
                />
              </a>

              <a href="https://twitter.com/tkyko13" target="_blank">
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/twIcon.png"
                  alt
                />
              </a>

              <a href="https://github.com/tkyko13" target="_blank">
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/githubIcon.png"
                  alt
                />
              </a>

              <a href="https://zenn.dev/tkyko13" target="_blank">
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/zennIcon.png"
                  alt
                />
              </a>

              <a href="https://qiita.com/tkyko13" target="_blank">
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/qiitaIcon.png"
                  alt
                />
              </a>

              <a href="https://qiitadon.com/@tkyko13" target="_blank">
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/mastdonIcon.png"
                  alt
                />
              </a>

              <a href="https://www.instagram.com/tkyko13/" target="_blank">
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/instaIcon.png"
                  alt
                />
              </a>

              <a
                href="https://www.youtube.com/channel/UCbjq5_me6LcGNXktXDHgZqQ"
                target="_blank"
              >
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/youtubeIcon.png"
                  alt
                />
              </a>

              <a
                href="https://openprocessing.org/user/41827?view=sketches"
                target="_blank"
              >
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/openprocessingIcon.png"
                  alt
                />
              </a>
              <a
                href="https://protopedia.net/prototyper/tkyko13"
                target="_blank"
              >
                <img
                  class="profile-sns-icon"
                  src="@/assets/icon/protopediaIcon.png"
                  alt
                />
              </a>
            </div>
            <p>
              ゲーム，電子工作，Webアプリ，インタラクティブ，メディアアート，ジェネレイティブアート，講師
            </p>
          </div>
        </div>
      </div>

      <div id="article-list" class="row">
        <div class="col-sm-6 col-12">
          <a
            href="https://qiita.com/tkyko13"
            data-qiita-widget
            data-username="tkyko13"
          ></a>
        </div>
        <div class="col-sm-6 col-12">
          <a
            class="twitter-timeline"
            data-height="400"
            href="https://twitter.com/tkyko13?ref_src=twsrc%5Etfw"
            >Tweets by tkyko13</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'profile',
  mounted() {
    let scriptEl = document.createElement('script');
    scriptEl.setAttribute('src', 'https://qiita-widget.suin.io/widget.js');
    document.head.appendChild(scriptEl);
    let scriptElTw = document.createElement('script');
    scriptElTw.setAttribute('src', 'https://platform.twitter.com/widgets.js');
    document.head.appendChild(scriptElTw);
  },
};
</script>

<style>
#profile {
  margin-top: 3rem;
}

#profile-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.profile-sns-icon {
  width: 25px;
  height: 25px;
  display: inline-block;
  /* padding: 1rem; */
  margin: 0.3rem;
}

#myFace {
  width: 128px;
  height: 128px;
}
#profileDescription {
  margin: 1rem;
}
</style>
